<div [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
     [style.height]="reportTable.height" [style.position]="'absolute'" >
  <table *ngIf="reportTable.tableType === 'surveyTable'" [style]="tableStyle"
    [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
    [style.height]="reportTable.height" [style.font-size]="reportTable.fontSize">
    <thead>
      <tr>
        <th [style.border]="'none'"></th>
        <th *ngFor="let column of reportTable?.columnList" [style.width]="column.width+'mm'" [style.border]="reportTable?.cellBorder"
            [style.padding]="reportTable?.cellPadding+'mm'" [style.text-align]="column.textAlignment">
          <p [style]="column.textOrientation === 'vertical' ? uprightTextStyle : ''">{{column?.label}}</p>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of reportTable?.rowList">
        <th [style.border]="reportTable?.cellBorder"
            [style.padding]="reportTable?.cellPadding+'mm'" [style.text-align]="row.textAlignment">{{row?.label}}</th>

        <td [style.display]="row?.isCategory ? 'none' : ''" *ngFor="let column of reportTable?.columnList" [style.border]="reportTable?.cellBorder"
             [style.padding]="reportTable?.cellPadding+'mm'" [style.text-align]="column.textAlignment">
          <input *ngIf="column.inputType==='checkbox'" [name]="row?.label" type="checkbox" />
          <input *ngIf="column.inputType==='text'" [style]="contentFitStyle" type="text" />
          <input *ngIf="column.inputType==='radio'" [name]="row?.label" type="radio" />
          <textarea *ngIf="column.inputType==='textarea'" [style]="contentFitStyle"></textarea>
          <select *ngIf="column.inputType==='select'" [style]="contentFitStyle"></select>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="reportTable.tableType === 'genericTable'">
    <table [style.top]="reportTable.top" [style.left]="reportTable.left" [style.width]="reportTable.width"
           [style.height]="reportTable.height" [style.font-size]="reportTable.fontSize">
      <thead>
        <tr>
          <th *ngFor="let column of reportTable?.columnList" [style.width]="column.width+'mm'" [style.border]="reportTable?.cellBorder"
              [style.padding]="reportTable?.cellPadding+'mm'" [style.text-align]="column.textAlignment">
            <p [style]="column.textOrientation === 'vertical' ? uprightTextStyle : ''">{{column?.label}}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td *ngFor="let column of reportTable?.columnList" [style.border]="reportTable?.cellBorder"
              [style.padding]="reportTable?.cellPadding+'mm'" [style.text-align]="column.textAlignment"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
